export const isDateToday = (date: Date) => {
  const now = new Date();
  return (
    date.getUTCFullYear() === now.getUTCFullYear() &&
    date.getUTCMonth() === now.getUTCMonth() &&
    date.getUTCDate() === now.getUTCDate()
  );
};

/**
 * Calculate the number of days between two dates (ignoring time).
 * Returns a positive number if `to` is after `from`.
 */
export const getDaysDifference = (from: Date, to: Date): number => {
  const fromStart = Date.UTC(
    from.getUTCFullYear(),
    from.getUTCMonth(),
    from.getUTCDate(),
  );
  const toStart = Date.UTC(
    to.getUTCFullYear(),
    to.getUTCMonth(),
    to.getUTCDate(),
  );
  return Math.round((toStart - fromStart) / (24 * 60 * 60 * 1000));
};

/**
 * Gets the closest virtual monthly renewal of a date, so, if you make your
 * a subscription on the 2nd of a month, it gives the closest 2nd of a month.
 *
 * @example
 *  new Date(); // 2026-02-11T16:24:53.507Z
 *  getClosestMonthlyRenewal(new Date("2024-05-16T12:16:15Z")) // 2026-01-16T12:16:15.000Z
 */
export function getClosestMonthlyRenewal(subscriptionDate: Date) {
  // Insight:
  //  last billing cycle start before now === first billing cycle start after (1 month ago)

  const monthAgo = new Date();
  monthAgo.setUTCMonth(monthAgo.getUTCMonth() - 1);

  // Copying the date here, since Date is mutable (Temporal pls)
  const workingDate = new Date(subscriptionDate.getTime());
  while (workingDate < monthAgo) {
    workingDate.setUTCMonth(workingDate.getUTCMonth() + 1);
  }

  return workingDate;
}
